import { render } from "./pageError.vue?vue&type=template&id=69d78840&scoped=true"
import script from "./pageError.vue?vue&type=script&lang=js"
export * from "./pageError.vue?vue&type=script&lang=js"

import "./pageError.vue?vue&type=style&index=0&id=69d78840&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d78840"]])

export default __exports__